import React from 'react';

import { FaceGrinHeartsIcon } from '../../icons/face-grin-hearts';
import { FaceLaughRelaxedIcon } from '../../icons/face-laugh-relaxed';
import { FaceSmileIcon } from '../../icons/face-smile';
import { InterHeaderStyles } from '../../styles';

const getIconFromScore = (score: number) => {
  let icon;
  if (score < 50 || !score) {
    icon = <FaceSmileIcon />;
  } else if (score < 71) {
    icon = <FaceLaughRelaxedIcon />;
  } else {
    icon = <FaceGrinHeartsIcon />;
  }
  return (
    <div className="flex items-start">
      <span className="mr-2 mt-[-1px]">{icon}</span>
      <span className={InterHeaderStyles}>{score?.toFixed(0) || 0}</span>
    </div>
  );
};

export const EngagementScoreTemplate: any = ({ value }: { value: number }) => {
  return getIconFromScore(value);
};
